<mat-dialog-content class="mat-typography">
  <p [innerHTML]="data.message" class="p-5 border-bottom"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [mat-dialog-close]="true" cdkFocusInitial class="btn btn-primary">{{data.close}}</button>
</mat-dialog-actions>